export default __webpack_public_path__ + "static/media/Frances 9781408339381.2549666e.jpg";